
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle, memo } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';

import Search from '@mui/icons-material/Search';
import AlertNotification from '../components/AlertNotification';
import PdfViewerComponent from './PdfViewerComponent';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,
    DocumentUtility,
    UtilityLibrary,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    FetchControls,
    DeterminePermissions,
    CaseWorkflowService,
    SharedService
} from '../components/ComponentsLibrary';
import PageLoader from '../components/PageLoader';

import { useConfigContext } from '../functions/ConfigContext';
import { ClientType } from '../enums/ClientType'

const CaseInformation = memo(forwardRef((props, ref) => {

    const {
        onCaseSearchComplete = () => { },
        onBatchDocAvailable = () => { },
        onMessageUpdate = () => { },

    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onSelectCaseFromExternal,
        onSelectCaseFromMemory,
        onLoadDocFromBatchExternal,
        onLoadNextDocFromBatchExternal,
        addNewDocumentToGridRow,
        onDisableCaseInfoForm,
        clearCaseInfoFromExternal,
        clearAllCaseUIState,
    }));

     const { configLibrary } = useConfigContext();

    const errorFormName = "Case Information";

    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmationDialogContent, setConfirmationDialogContent] = useState([]);

    const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
    const [notificationDialogContent, setNotificationDialogContent] = useState([]);
    const [timerNotificationDialogClose, setTimerNotificationDialogClose] = useState(5000);
    const [timerAutoCloseNotificationDialog, setTimerAutoCloseNotificationDialog] = useState(false);
    const [notificationDialogPosition, setNotificationDialogPosition] = useState("center")

    const [caseInfoFormVisibility, setCaseInfoFormVisibility] = useState(false);
    const [currentBatchFormData, setCurrentBatchFormData] = useState({}); // RC changed it to an object because its an object when not empty

    const customDateFormat = "MM/DD/YYYY hh:mm A";
    const caseUniqueID = "caseNumber";

    const batchDocumentProcess = EnumUtility.BatchDocumentProcess;

    // Create a ref for the child component
    const pdfViewerRef = useRef(null);
    const [splitArgs, setSplitArgs] = useState(null);
    const [pendingEditorCloseAction, setPendingEditorCloseAction] = useState(null);
    // Get the Document Viewer License Key
    const siteSettingDetail = JSON.parse(SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey));
    const docViewerLicenseKey = siteSettingDetail.DocViewerLicenseKey || "";
    const masterServerDBSchema = siteSettingDetail.masterDBSchema || "";
    const softLockTimer = parseInt(siteSettingDetail.SoftLockTimer, 10) || 30;
    const mdhsImportSweepProcessID = parseInt(siteSettingDetail.MDHSImportSweepProcessID, 10) || 0;
    const stateID = SessionManager.GetDataFromSession("LoginUserInfoKey")?.stateID
    

    const CaseTabType = {
        BATCH: { ID: 100, label: "Batch" },
        CaseExternal: { ID: 200, label: "Case External" },
        CASE: { ID: 300, label: "Case" },
    };

    const [getBatchDocument, setBatchDocument] = useState({
        BatchID: 0,
        BatchDocumentID: 0,
        DocumentPath: '',
        DocumentUNCPath: '',
        DocumentName_Displayed: ''
    });

    const TabPanel = ({ children, value, index }) => (
        <div style={{ visibility: value === index ? "visible" : "hidden" }}>{children}</div>
    );

    const dataRefs = useRef({}); // Store form and DataGrid data persistently
    /* const currentActiveBatchTab = batchTabs.find((tab) => tab.uniqueID === currentBatchTab);
    const currentBatchTabData = currentActiveBatchTab ? (currentActiveBatchTab.tabKey !== CaseTabType.BATCH.ID ? dataRefs.current[currentActiveBatchTab.pid] : null) : null;
    const currentBatchFormData = currentBatchTabData ? currentBatchTabData.formData : []; */


    const scrollRef = useRef(null);
    const [document, setDocument] = useState({ 0: { value: "" } });
    const [enableShowBatchDocument, setEnableShowBatchDocument] = useState(false);
    const [uncBatchDocumentUrl, setUncBatchDocumentUrl] = useState('');


    const [isPageLoading, setIsPageLoading] = useState(false);

    const [testDocLoad, setTestDocLoad] = useState(false);

    /* 
    const [caseDataSessionKey, setCaseDataSessionKey] = useState('CaseDetailsKey');
    const [getCaseDetailsAPI, setGetCaseDetailsAPI] = useState('https://localhost:7183/api/Case/GetCaseList/');
    const [getCaseDocumentsAPI, setGetCaseDocumentsAPI] = useState('https://localhost:7183/api/CaseDocument/GetCaseDocumentList/0/'); */

    const [resultsDocs, setDocResults] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [docsSelectedForExport, setDocsSelectedForExport] = useState([]);
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });

    const defaultPermissionsForFields = {
        caseNumberTxt: { read: false, write: true, hide: false },
        caseSearchDgrd: { read: false, write: true, hide: false },
        caseNumberLbl: { read: false, write: true, hide: false },
        cpNameLbl: { read: false, write: true, hide: false },
        cpSSNLbl: { read: false, write: true, hide: false },
        ncpNameLbl: { read: false, write: true, hide: false },
        ncpSSNLbl: { read: false, write: true, hide: false },
        statusTypeLbl: { read: false, write: true, hide: false },
        caseTypeLbl: { read: false, write: true, hide: false },
        openedLbl: { read: false, write: true, hide: false },
        caseWorkerLbl: { read: false, write: true, hide: false },
        countyNameLbl: { read: false, write: true, hide: false },
        familyViolenceLbl: { read: false, write: true, hide: false },
        ndiLbl: { read: false, write: true, hide: false },
        confidentialCaseLbl: { read: false, write: true, hide: false },
        goodCauseLbl: { read: false, write: true, hide: false },
        nonCoopLbl: { read: false, write: true, hide: false },
        conflictCaseLbl: { read: false, write: true, hide: false },
        caseClosedLbl: { read: false, write: true, hide: false },
        uploadFileBtn: { read: false, write: true, hide: false },
        caseDetailSelect: { read: false, write: true, hide: false },
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: true, hide: false },
        documentsDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrRotateBtn: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
        docVwrDeleteBtn: { read: false, write: true, hide: false },
        docVwrSaveBtn: { read: false, write: true, hide: false },
    };
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);
    const [permissions, setPermissions] = useState({});
    const [permissions_ByEvent, setPermissions_ByEvent] = useState({});

    const documentViewerAccessPermissions = {
        viewOnlyAccess: false,
        editorAccess: formFieldAccess.docVwr1Editor,
        viewerToolbarItemsAccess: formFieldAccess.docVwr1ToolbarItems,
        rotateButtonAccess: formFieldAccess.docVwrRotateBtn,
        splitButtonAccess: formFieldAccess.docVwrSplitBtn,
        deleteButtonAccess: formFieldAccess.docVwrDeleteBtn,
        saveButtonAccess: formFieldAccess.docVwrSaveBtn,
    };

    const toUpperCase = (stringToUpperCase) => {
        return String(stringToUpperCase).toUpperCase();
    };

    const toLowerCase = (stringToLowerCase) => {
        return String(stringToLowerCase).toLowerCase();
    };

    const [alertProps, setAlertProps] = useState({
        type: '',
        message: '',
        open: false,
    });


    const showAlert = (type, message) => {
        setAlertProps({ type, message, open: true });
    };

    const handleBatchLockNotification = (lockAnalysis) => {
        if (!lockAnalysis?.isLockedByOtherUser) {
            return;
        }

        handleNotificationDialog({
            Title: "Warning",
            Message: lockAnalysis.lockMessage,
            NotificationType: EnumUtility.NotificationType.Warning
        });
    };

    const checkBatchLockBeforeDocumentAction = async (actionName) => {
        try {
            const batchID = getBatchDocument.BatchID;
            if (!batchID) {
                return { isLocked: false };
            }

            const lockData = await ApiManager.GetBatchLockStatusFromApi({
                batchID,
                masterServerDBSchema,
                softLockTime: softLockTimer
            });

            const loginUserInfo = sessionService.getUser();
            const currentUserId = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
            const analysis = ApiManager.AnalyzeBatchLockStatus(lockData, currentUserId);

            if (analysis.isLockedByOtherUser) {
                handleBatchLockNotification(analysis);
                return { isLocked: true };
            }

            return { isLocked: false };
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, actionName || "checkBatchLockBeforeDocumentAction");
            return { isLocked: false };
        }
    };

    const postHardLockAfterSuccessfulEdit = async (batchID, actionName = "postHardLockAfterSuccessfulEdit") => {
        try {
            if (!batchID) {
                return;
            }

            const loginUserInfo = sessionService.getUser();
            const currentUserId = loginUserInfo ? loginUserInfo.legacyUserID : -123456;

            await ApiManager.PostBatchLockStatusToApi({
                batchID,
                lockValue: 2,
                userLoginID: currentUserId,
                masterServerDBSchema,
            });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, actionName);
        }
    };

    //=======================================================================
    // Get Methods - Begin
    //=======================================================================


    // CODE_MODIFY: Modify the below function to fetch data from API
    const getCaseDataFromSessionByID = (caseID) => {
        try {
            return SessionManager.GetDataFromSessionByValue(caseID, caseUniqueID, SessionManager.CaseInformationKey);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDataFromSessionByID", {});
        }
    };

    
    const getCaseInfoFromApiByID = async (caseID) => {
        try {
            const params = {
                caseNumber: caseID,
                apiMainframeUrl: configLibrary.apiMainframeUrl,
                masterServerDBSchema //Added to params
            };
            const caseApiData = await ApiManager.GetCaseDataFromApiByID(params);

            // The caseApiData should be a standardized object.
            if (!Array.isArray(caseApiData.caseInfo) && caseApiData.caseInfo) {
                // If it's a single object, handle it as before
                caseApiData.caseInfo.lastViewed = new Date().toISOString();

                SessionManager.AddOrUpdateParent([caseApiData.caseInfo], caseUniqueID, SessionManager.CaseInformationKey);
                return {
                    caseInfo: caseApiData.caseInfo,
                    statusCode: caseApiData.statusCode,
                    errorMessage: caseApiData.errorMessage
                };
            }
            else {
                return {
                    caseInfo: null,
                    statusCode: caseApiData.statusCode,
                    errorMessage: caseApiData.errorMessage
                };
                //return null;
            }           
        }
        catch (error){
            throw LoggerUtility.ProcessErrorData(error, "getCaseInfoFromApiByID", {});
        }

    };

    const getCaseDataByID = async (caseID) => {
        try {
            // const caseSessionData = getCaseDataFromSessionByID(caseID);
            // if (caseSessionData) {
            //     const updatedResponse = { ...caseSessionData, "lastViewed": new Date().toISOString() };
            //     SessionManager.AddOrUpdateParent(updatedResponse, caseUniqueID, SessionManager.CaseInformationKey);

            //     return {
            //         caseInfo: caseSessionData,
            //         statusCode: EnumUtility.CaseSearchResultCode.CaseFound.ID,
            //         errorMessage: ''
            //     };
            // }
            // else {
            //     return await getCaseInfoFromApiByID(caseID);
            // }

            return await getCaseInfoFromApiByID(caseID); // MJQ - Always go to the state system. Do not return previously pulled data

        } catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDataByID", {});
        }
    };


    const addCaseInfoToDataRefs = async (caseID) => {
        try {
            let hasCaseData = true;
            // If data is not already loaded, fetch and store it
            //if (!dataRefs.current[caseID]) {  // MJQ - Always go to the state system. Do not return previously pulled data
            const caseInfoData = await getCaseDataByID(caseID);
            if ([EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.ID,
            EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.ID].includes(caseInfoData.statusCode)) {
                return caseInfoData;
            }
            let caseData = caseInfoData.caseInfo;

            if (caseData?.caseNumber) {
                caseData = await CaseWorkflowService.buildYTracCaseData(caseData, stateID);
                const groupedData = {
                    formData: caseData,
                }

                dataRefs.current[caseID] = groupedData;
            }
            else {
                hasCaseData = false;
            }
            return { hasCaseData, caseData: caseData, statusCode: caseInfoData.statusCode, errorMessage: caseInfoData.errorMessage };


        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addCaseInfoToDataRefs", {});
        }
    };

    const assignAllCaseDataFromSessionToRefs = () => {
        try {
            // Retrieve session data
            const storedData = SessionManager.GetDataFromSession(SessionManager.CaseInformationKey);
            if (storedData.length > 0) {
                storedData.forEach((record) => {
                    const primaryKey = record.caseNumber;
                    if (!primaryKey) return; // Skip records without a primary key

                    // Initialize the dataRefs object for this record
                    if (!dataRefs.current[primaryKey]) {
                        dataRefs.current[primaryKey] = { formData: {}, gridData: [] };
                    }

                    // Assign all values except the gridData array
                    Object.keys(record).forEach((key) => {
                        if (Array.isArray(record[key])) {
                            // If it's an array, treat it as gridData
                            dataRefs.current[primaryKey].gridData = record[key];
                        } else {
                            // Otherwise, store it in formData
                            dataRefs.current[primaryKey].formData[key] = record[key];
                        }
                    });
                });
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "assignAllCaseDataFromSessionToRefs", {});
        }
    };


    useEffect(() => {
        try {
            assignAllCaseDataFromSessionToRefs();
        }
        catch (error) {
            LoggerUtility.ManageErrorLogging(error, errorFormName, "assignAllCaseDataFromSessionToRefs - Page Load");
        }
    }, []);


    //=======================================================================
    // Get Methods - End
    //=======================================================================



    //=======================================================================
    // Action Events - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    };

    const handleAlertClose = () => {
        setAlertProps((prevState) => ({ ...prevState, open: false }));
    };

    //=======================================================================
    // Action Events - End
    //=======================================================================



    //=======================================================================
    // Batch Document - On load of external batch document  - Begin
    //=======================================================================

    const getBatchDocsByBatchID = async (batchID, isSplit = false) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            const loginUserInfo = sessionService.getUser();
            const loginLegacyUserID = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
            const params = {
                loginID: loginLegacyUserID,
                onlyBatchID: batchID
            }
            const batchDocsApiData = await ApiManager.GetBatchDocsFromApiByBatchID(params);
            if (batchDocsApiData.length > 0) {
                await LoadDocByBatchID(batchDocsApiData, isSplit);
            }
            else {
                clearBatchDocumentArray();
                onBatchDocAvailable(batchDocumentProcess.DocumentNotAvailable, []);
                onMessageUpdate("No Document Found!");
            }
        }
        catch (error) {
            clearBatchDocumentArray();
            onBatchDocAvailable(batchDocumentProcess.ErrorLoadingDocument, []);
            onMessageUpdate("No Document Found!");

            throw LoggerUtility.ProcessErrorData(error, "getBatchDocsByBatchID", {});
        }
        finally { setIsPageLoading(false); }
    };

    const LoadDocByBatchID = async (batchDocsData, isSplit = false) => {
        try {
            // Filter completed and pending items
            const completedItems = batchDocsData.filter(item => item.documentStatusID === 5);
            const pendingItems = batchDocsData.filter(item => item.documentStatusID === 32);

            if (pendingItems.length > 0) {

                // Sort pending items by doc_Id first, then by id
                const sortedPendingItems = pendingItems.sort((a, b) => {
                    if (a.documentOrder !== b.documentOrder) {
                        return a.documentOrder - b.documentOrder; // Sort by Document Order
                    }
                    return a.batchDocumentID - b.batchDocumentID; // Tie-breaker: Sort by Batch Document ID if Document Order is same
                });

                sortedPendingItems.forEach(item => {
                    item.indexComplete = false;
                });

                // Pick the first pending item
                const firstPendingItem = sortedPendingItems[0];

                // Calculate the 1-based index for the first pending item, considering completed items
                const indexOfFirstPendingItem = completedItems.length + 1;

                const batchDocumentData = {
                    sortedBatchDocs: sortedPendingItems,
                    currentDocCount: indexOfFirstPendingItem,
                    TotalDocCount: batchDocsData.length,
                    currentIndex: 0
                };

                SessionManager.SetSession(SessionManager.BatchDocumentsKey, JSON.stringify(batchDocumentData));

                if (firstPendingItem) {
                    await ProcessPendingBatchDocument(firstPendingItem, indexOfFirstPendingItem, batchDocsData.length, isSplit);
                }
                else {
                    clearBatchDocumentArray();
                    onBatchDocAvailable(batchDocumentProcess.NoPendingDocuments, []);
                    onMessageUpdate("No Document Found!");
                }
            }
            else {
                clearBatchDocumentArray();
                onBatchDocAvailable(batchDocumentProcess.NoPendingDocuments, []);
                onMessageUpdate("No Document Found!");
            }
        }
        catch (error) {
            clearBatchDocumentArray();
            onBatchDocAvailable(batchDocumentProcess.ErrorLoadingDocument, []);
            onMessageUpdate("No Document Found!");

            throw LoggerUtility.ProcessErrorData(error, "LoadDocByBatchID", {});
        }
    };


 const ProcessPendingBatchDocument = async (batchDocData, currentDocCount, totalDocCount, isSplit = false) => {
    try {
        if (batchDocData) {
            {
                // Note: this block must always run, even after a split (isSplit=true) - GetFileUncPath fetches
                // the document's current bytes and returns a brand-new blob URL each call, which is required
                // to force the PdfViewerComponent (keyed on this URL) to reload the just-updated document
                // instead of continuing to show the pre-split content under an unchanged key.
                const docsUncAPI = ApiManager.DocumentUncApiUrl;

                const { hasError, isFileExists, fileUrl, errorList } = await DocumentUtility.GetFileUncPath(
                    docsUncAPI,
                    batchDocData.documentUNCPath
                );

                if (hasError) {
                    const currentDate = UtilityLibrary.formatDate(new Date(), customDateFormat);
                    const loginUserInfo = sessionService.getUser();
                    const { stateName, firstName, lastName } = loginUserInfo;

                    const dialogMessage = `Document Preview Failed. Please contact Helpdesk.
                        Exception = 'Failed to retrieve document from the path
                        Date/Time of Error = ${currentDate}
                        State = ${stateName}
                        Page = 'Index'
                        User = ${firstName} ${lastName}
                        Region =  ${configLibrary.hostedEnvironment}            
                        Batch ID = ${batchDocData.batchID}
                        Document ID = ${batchDocData.batchDocumentID}`;

                    handleNotificationDialog({ NotificationType: "error", Message: dialogMessage });
                }

                const batchDocumentData = await ApiManager.GetBatchDocumentByIDFromApi({
                    batchDocumentID: batchDocData.batchDocumentID
                });
                const fallbackDocumentName =
                    batchDocumentData?.documentName ??
                    batchDocumentData?.DocumentName ??
                    batchDocData.documentName;
                let documentNameDisplayed = fallbackDocumentName;

                if (mdhsImportSweepProcessID > 0 && batchDocData.sweepProcessID === mdhsImportSweepProcessID) {
                    const metadata = await ApiManager.GetMetadataFromApi(
                        batchDocumentData?.documentUNCPath ?? batchDocData.documentUNCPath,
                        fallbackDocumentName
                    );
                    documentNameDisplayed =
                        metadata?.documentName ??
                        metadata?.DocumentName ??
                        fallbackDocumentName;
                }

                setBatchDocument({
                    BatchID: batchDocData.batchID,
                    BatchDocumentID: batchDocData.batchDocumentID,
                    DocumentPath: fileUrl,
                    DocumentUNCPath: batchDocData.documentUNCPath,
                    DocumentName_Displayed: documentNameDisplayed
                });

                await setBatchDocumentInViewer(batchDocData.batchDocumentID, fileUrl);
            }

            let statusID = 0;

            if (currentDocCount === totalDocCount) {
                statusID = 3;
            } else {
                statusID = 2;
            }

            const updatedBatchDoc = { ...batchDocData, batchStatusID: statusID };

            onBatchDocAvailable(batchDocumentProcess.HasDocumentForIndex, updatedBatchDoc);
            onMessageUpdate("Document " + currentDocCount + " of " + totalDocCount);

            /* if (!isFileExists) {
                handleNotificationDialog(EnumUtility.NotificationAlerts.DocumentNotFound);
            } */
        } else {
            clearBatchDocumentArray();
            onBatchDocAvailable(batchDocumentProcess.NoPendingDocuments, []);
            onMessageUpdate("No Document Found!");
        }
    }
    catch (error) {
        clearBatchDocumentArray();
        onBatchDocAvailable(batchDocumentProcess.ErrorLoadingDocument, []);
        onMessageUpdate("No Document Found!");

        throw LoggerUtility.ProcessErrorData(error, "ProcessPendingBatchDocument", {});
    }
};

    // Function to handle the process of documents post the split of a document
    const handleLoadDocAfterSplit = async (batchID) => {
        try {
            //setSelectedData([]);
            await getBatchDocsByBatchID(batchID, true);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleLoadDocAfterSplit");
        }
    };

    // Function to handle loading of document from batch by external component
    const onLoadDocFromBatchExternal = async (batchID, showExtDocGrid) => {
        try {
            //setSelectedData([]);
            await getBatchDocsByBatchID(batchID);
            clearBatchCaseDataForm(batchID, showExtDocGrid);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadDocFromBatchExternal");
        }
    };

    // Function to handle loading of next document from batch by external component
    const onLoadNextDocFromBatchExternal = async (batchID, showExtDocGrid, batchDocData, currentDocCount, totalDocCount) => {
        try {
            clearBatchCaseDataForm(batchID, showExtDocGrid);
            //setSelectedData([]);
            await ProcessPendingBatchDocument(batchDocData, currentDocCount, totalDocCount);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadNextDocFromBatchExternal");
        }
    };

    const clearBatchCaseDataForm = (batchID, showExtDocGrid) => {
        try {
            setCaseInfoFormVisibility(true);
            setCurrentBatchFormData({});
            setFormFieldAccess(prev => ({...prev,
                confidentialCaseLbl: { ...prev.confidentialCaseLbl, hide: true },
                familyViolenceLbl: { ...prev.caseInfoFormVisibility, hide: true }}
            ))
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "clearBatchCaseDataForm", {});
        }
    };

    // Function to clear case information from the tabs if present on click of "No Case" in "New Document" page
    const clearCaseInfoFromExternal = (batchID, showExtDocGrid) => {
        try {
            clearBatchCaseDataForm(batchID, showExtDocGrid);
            //setSelectedData([]);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "clearCaseInfoFromExternal", {});
        }
    };

    const setBatchDocumentInViewer = async (batchDocumentID, completeDocumentPath) => {
        try {
            setUncBatchDocumentUrl(completeDocumentPath);
            setEnableShowBatchDocument(true);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "setBatchDocumentInViewer", {});
        }
    };

    const clearBatchDocumentArray = async () => {
        try {
            setBatchDocument({ BatchID: 0, BatchDocumentID: 0, DocumentPath: '' , DocumentUNCPath: '', DocumentName_Displayed: ''});
            setEnableShowBatchDocument(false);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "clearBatchDocumentArray", {});
        }
    };

    //=======================================================================
    // Batch Document - On load of external batch document - End
    //=======================================================================


    //=======================================================================
    //  Methods - Begin
    //=======================================================================

    // Function to select previously searched case from app memory without a new case search
    const onSelectCaseFromMemory = async (caseID, caseSearchSource) => {
        try {
            const normalizedCaseID = toUpperCase(caseID);
            let caseData = dataRefs.current[normalizedCaseID]?.formData;

            if (!caseData?.caseNumber) {
                const sessionCaseData = getCaseDataFromSessionByID(normalizedCaseID);
                if (!sessionCaseData?.caseNumber) {
                    return false;
                }

                caseData = await CaseWorkflowService.buildYTracCaseData(sessionCaseData, stateID);
                dataRefs.current[normalizedCaseID] = {
                    formData: caseData,
                    gridData: dataRefs.current[normalizedCaseID]?.gridData || sessionCaseData.caseDocs || []
                };
            }

            setCurrentBatchFormData(caseData);

            if (onCaseSearchComplete) {
                onCaseSearchComplete(true, {
                    caseData,
                    statusCode: EnumUtility.CaseSearchResultCode.CaseFound.ID,
                    errorMessage: ''
                }, caseSearchSource);
            }

            return true;
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "onSelectCaseFromMemory", {});
        }
    };
    
    // Function to handle loading of case from external search
    const onSelectCaseFromExternal = async (caseID, showExtDocGrid, caseSearchSource) => {
        console.log("onselectcasefromexternal")
        try {
            let caseInfoData = await addCaseDetailsFromExternal(toUpperCase(caseID), showExtDocGrid);


            // Handle both string and object error messages
            let errorMessageText = '';
            
            if (typeof caseInfoData.errorMessage === 'string') {
                errorMessageText = caseInfoData.errorMessage;
            } else if (typeof caseInfoData.errorMessage === 'object' && caseInfoData.errorMessage?.Message) {
                errorMessageText = caseInfoData.errorMessage.Message;
            }

            const loginUserInfo = sessionService.getUser();
            const userStateID = loginUserInfo ? loginUserInfo.stateID : -1;
            // only for state systems
            
            // Removed this because warning message was popping twice
            // Check for case not found using multiple conditions
            if (![ClientType.ErrorType.MainframeDisconnected, ClientType.ErrorType.ScraperDisconnected].includes(caseInfoData.statusCode) && (errorMessageText === "Could not locate case in the system. Please verify the case number and try again." ||
                !caseInfoData.hasCaseData)) {
                console.log("🔍 Case not found - showing notification");
                const caseNotFoundError = EnumUtility.getCaseNumberNotFoundError(userStateID);
                
            //     // Only show error if user is in MS/KS/WY
            //     if (caseNotFoundError) {
            //         handleNotificationDialog(caseNotFoundError);  
            //     }
            }

            const caseSearchInfo = {
                caseData: caseInfoData.caseData,
                statusCode: caseInfoData.statusCode, 
                errorMessage: caseInfoData.errorMessage
            }
            if (caseInfoData.hasCaseData) {
                if (onCaseSearchComplete) {
                    onCaseSearchComplete(true, caseSearchInfo, caseSearchSource);
                }
            }
            else {
                clearCaseInfoFromExternal(getBatchDocument.BatchID, false);
                if (onCaseSearchComplete) {
                    onCaseSearchComplete(false, caseSearchInfo, caseSearchSource);
                }
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "onSelectCaseFromExternal", {});
        }
    };

    // Function to handle clearing of case tab from external search
    const onDisableCaseInfoForm = async () => {
        try {
            setCaseInfoFormVisibility(false);
            setCurrentBatchFormData({});
            setFormFieldAccess(prev => ({...prev,
                confidentialCaseLbl: { ...prev.confidentialCaseLbl, hide: true },
                familyViolenceLbl: { ...prev.caseInfoFormVisibility, hide: true }}
            ))
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "onDisableCaseInfoForm", {});
        }
    };

    // Clear all case UI state to prevent confidential case bug
    const clearAllCaseUIState = async () => {
        try {
            // Clear component state
            setCurrentBatchFormData({});
            // setCaseInfoFormVisibility(false);
            
            // Clear dataRefs cache
            dataRefs.current = {};
            
            // Clear session storage for case information
            SessionManager.ClearSessionValue(SessionManager.CaseInformationKey);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "clearAllCaseUIState", {});
        }
    };

    const addCaseDetailsFromExternal = async (caseID, showExtDocGrid) => {
        try {
            caseID = toUpperCase(caseID);
            // const newTab = { tabKey: CaseTabType.CaseExternal.ID, uniqueID: caseID + "_" + tabIndexCounter, pid: caseID, label: `CID: ${caseID}`, showDocumentGrid: showExtDocGrid, canDelete: false }
            let hasCaseData = false;

            const caseInfoData = await addCaseInfoToDataRefs(caseID);
             if ([EnumUtility.CaseSearchResultCode.MFSessionDisconnectError,
                EnumUtility.CaseSearchErrorMessage.ScraperDisconnectedError].includes(caseInfoData.statusCode)){
                return {
                    hasCaseData: hasCaseData,
                    caseData: null,
                    statusCode: caseInfoData.statusCode,
                    errorMessage: caseInfoData.errorMessage,
                };
            }
            hasCaseData = caseInfoData.hasCaseData;
            if (hasCaseData) {
                const currentCaseData = dataRefs.current[caseID];
                const currentCaseFormData = currentCaseData ? currentCaseData.formData : {};
                setCurrentBatchFormData(currentCaseFormData);
            }
            return { hasCaseData, caseData: caseInfoData.caseData, statusCode: caseInfoData.statusCode, errorMessage: caseInfoData.errorMessage };
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addCaseDetailsFromExternal", {});
        }
    };

    const addNewDocumentToGridRow = async (caseID, newCaseDocumentData) => {
        try {
            caseID = toUpperCase(caseID);
            if (!dataRefs.current[caseID]) return;

            // Add new row to dataRefs
            dataRefs.current[caseID].gridData.push(newCaseDocumentData);

            const storedData = SessionManager.GetDataFromSession(SessionManager.CaseInformationKey);
            if (storedData.length > 0) {
                // Find and update the specific record in session
                const recordIndex = storedData.findIndex((rec) => toUpperCase(rec.caseNumber) === caseID);
                if (recordIndex !== -1) {
                    storedData[recordIndex].caseDocs.push(newCaseDocumentData);
                }

                // Save updated data back to session
                SessionManager.SetSession(SessionManager.CaseInformationKey, JSON.stringify(storedData));
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "addNewDocumentToGridRow", {});
        }
    };

    const onSelectDocsFromExternal = async (batchDocumentID, completeDocumentPath) => {
        try {
            setBatchDocumentInViewer(batchDocumentID, completeDocumentPath);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "onSelectDocsFromExternal", {});
        }
    };

    const handleNotificationDialog = (dialogContent, timerAutoClose = false, timeToClose = 5000, position = "center") => {
        try {
            setNotificationDialogContent(dialogContent);
            setTimerNotificationDialogClose(timeToClose);
            setTimerAutoCloseNotificationDialog(timerAutoClose);
            setNotificationDialogPosition(position);
            handleOpenNotificationDialog();
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleNotificationDialog", {});
        }
    };

    const handleOpenNotificationDialog = () => {
        try {
            setNotificationDialogOpen(true);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleOpenNotificationDialog", {});
        }
    };

    const handleCloseNotificationDialog = useCallback(() => {
        try {
            setNotificationDialogOpen(false);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleCloseNotificationDialog", {});
        }
    }, []);

    /* 
    * Authorization code starts here
    * The permission values for fields are received from Web API
    * The received data from Web API response is processed and stored in a state variable "formFieldAccess"
    */
    useEffect(() => {
        const fetchFormFieldPermissions = async () => {
            try {
                const loginUserInfo = sessionService.getUser();
                const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
                const params = {
                    clientID: loginStateID,
                    formID: 40      // To-do: Modify Code - Hard-coded value of FormID: 40
                }
                const controlSecurityListApiData = await ApiManager.FetchControlsPermissions(params);
                const actualPermissionsForFields = DeterminePermissions(controlSecurityListApiData);
               
                const updated = { ...defaultPermissionsForFields, ...actualPermissionsForFields };
                // Hide chip labels initially; they are shown/hidden based on case data in the currentBatchFormData useEffect
                const chipLabels = ["confidentialCaseLbl", "familyViolenceLbl", "caseClosedLbl"];
                chipLabels.forEach(key => {
                    if (updated[key]) {
                        updated[key] = { ...updated[key], hide: true };
                    }
                });

                setFormFieldAccess(updated);
            } catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "fetchFormFieldPermissions", {});
            }
        };

        try {
            fetchFormFieldPermissions();
        }
        catch (error) {
            LoggerUtility.ManageErrorLogging(error, errorFormName, "fetchFormFieldPermissions - Page Load");
        }
    }, []);

    useEffect(() => { 
        // Hide or show fvi, confidentail or closed chips based on casedata
        if (currentBatchFormData) {
            const showConfidentialChip = CaseWorkflowService.checkConfidential(currentBatchFormData)
            const showFVIChip = CaseWorkflowService.checkFamilyViolence(currentBatchFormData)
            const showCaseClosedChip = CaseWorkflowService.checkCaseClosed(currentBatchFormData);
             const showNdi = currentBatchFormData?.ndiChipDisplay?.trim();
            setFormFieldAccess({
                ...formFieldAccess,
                 ndiLbl: {
                    ...formFieldAccess.ndiLbl,
                    hide: !showNdi
                },
                confidentialCaseLbl: {
                    ...formFieldAccess.confidentilCaseLbl,
                    hide: !showConfidentialChip
                },
                familyViolenceLbl: {
                    ...formFieldAccess.familyViolenceLbl,
                    hide: !showFVIChip && !currentBatchFormData?.fviChipDisplay?.trim()
                },
                caseClosedLbl: {
                    ...formFieldAccess.caseClosedLbl,
                    hide: !showCaseClosedChip
                }
            })
        }
    },[currentBatchFormData])

    //=======================================================================
    //  Methods - End
    //=======================================================================


    //=======================================================================
    // Confirmation Dialog - Begin
    //=======================================================================

    const handleConfirmationDialog = (dialogContent) => {
        setConfirmationDialogContent(dialogContent);
        handleOpenConfirmDialog();
    };

    const handleOpenConfirmDialog = () => {
        setConfirmDialogOpen(true);
    };

    const handleCloseConfirmDialog = () => {
        setSplitArgs(null);
        setPendingEditorCloseAction(null);
        setConfirmDialogOpen(false);
    };

    const handleDocumentEditorCloseRequest = ({ hasSelectedPages, closeEditor }) => {
        if (!hasSelectedPages) {
            closeEditor();
            return false;
        }

        setPendingEditorCloseAction(() => closeEditor);
        handleConfirmationDialog(EnumUtility.ConfirmDialogType.CloseDocumentEditor);
        return false;
    };

    const handleDialogConfirmAction = async (dialogContentID) => {
        try {
            switch (dialogContentID) {

                case EnumUtility.ConfirmDialogType.SplitDocument.ID:
                    handleConfirmSplit();
                    break;

                case EnumUtility.ConfirmDialogType.SplitAllDocument.ID:
                    handleConfirmSplitAll();
                    break;

                case EnumUtility.ConfirmDialogType.DeleteDocumentPages.ID:
                    handleConfirmDelete();
                    break;

                case EnumUtility.ConfirmDialogType.CloseDocumentEditor.ID:
                    if (pendingEditorCloseAction) {
                        pendingEditorCloseAction();
                        setPendingEditorCloseAction(null);
                    }
                    break;

                default:
                    break;
            }

            setConfirmDialogOpen(false);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
        }
    };

    //=======================================================================
    // Confirmation Dialog - End
    //=======================================================================

    //=======================================================================
    // Delete Document page Process - Begin
    //=======================================================================

    // Handler for the Delete button press
    const handleDeleteButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
        try {
            const selectedPageIndexes = getSelectedPageIndexes();
            let docSplitData = batchDataService.getSplitDocumentData();

            if (selectedPageIndexes.length > 0 && selectedPageIndexes.length < docSplitData.batchInstance.totalPageCount) {
                const { isLocked } = await checkBatchLockBeforeDocumentAction("handleDeleteButtonPress");
                if (isLocked) {
                    return;
                }

                // Store the arguments for later use
                setSplitArgs({ setOperations, getSelectedPageIndexes });
                // Show the confirmation dialog
                handleConfirmationDialog(EnumUtility.ConfirmDialogType.DeleteDocumentPages);
            }
            else {
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitNotAvailable); //Prevent split button from being clicked if no pages are selected
            };
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDeleteButtonPress");
        }
    };

    // Handler for confirming the delete
    const handleConfirmDelete = async () => {
        try {
            if (splitArgs) {
                //const buttonType = "Delete";
                const buttonOperationType = EnumUtility.DocumentViewerOperationType.DeleteButton.ID;
                const { setOperations, getSelectedPageIndexes } = splitArgs;
                // Perform the split operation using the stored arguments
                await performSplitOperation(setOperations, getSelectedPageIndexes, buttonOperationType);
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleConfirmDelete");
        }
    };

    //=======================================================================
    // Delete Document page Process - End
    //=======================================================================


    //=======================================================================
    // Split Document Process - Begin
    //=======================================================================

    // Handler for the split button press
    const handleSplitButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
        try {
            const selectedPageIndexes = getSelectedPageIndexes();
            let docSplitData = batchDataService.getSplitDocumentData();

            if (selectedPageIndexes.length > 0) {
                const { isLocked } = await checkBatchLockBeforeDocumentAction("handleSplitButtonPress");
                if (isLocked) {
                    return;
                }

                // Store the arguments for later use
                setSplitArgs({ setOperations, getSelectedPageIndexes });
                // Show the confirmation dialog
                handleConfirmationDialog(EnumUtility.ConfirmDialogType.SplitDocument);
            }
            else {
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitNotAvailable); //Prevent split button from being clicked if no pages are selected
            };
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSplitButtonPress");
        }
    };

    // Handler for confirming the split
    const handleConfirmSplit = async () => {
        try {
            if (splitArgs) {
                //const buttonType = "Split";
                const buttonOperationType = EnumUtility.DocumentViewerOperationType.SplitButton.ID;
                const { setOperations, getSelectedPageIndexes } = splitArgs;
                // Perform the split operation using the stored arguments
                await performSplitOperation(setOperations, getSelectedPageIndexes, buttonOperationType);
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleConfirmSplit");
        }
    };

    // Function to perform the split operation
    const performSplitOperation = async (setOperations, getSelectedPageIndexes, buttonOperationType) => {
        try {
            let docSplitData = batchDataService.getSplitDocumentData();
            const totalpageIndexes = UtilityLibrary.itemsArray(docSplitData.batchInstance.totalPageCount);
            const selectedPageIndexes = getSelectedPageIndexes();
            const selectedPageIndexesForProcessing =
                buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID
                    && selectedPageIndexes.length === totalpageIndexes.length
                    ? selectedPageIndexes.slice(1)
                    : selectedPageIndexes;
            const remainingPageIndexes = UtilityLibrary.differenceArray(totalpageIndexes, selectedPageIndexesForProcessing);

            if (selectedPageIndexesForProcessing.length > 0) { //TODO Plan A. Prevent split button from being active if no pages are selected
                selectedPageIndexesForProcessing?.length && setOperations((operations) => {

                    if (docSplitData.batchInstance) {
                        docSplitData.batchInstance.exportPDFWithOperations([
                            ...operations,
                            { type: "removePages", pageIndexes: remainingPageIndexes },
                        ]).then(async (buffer) => {
                            //this is only necessary if you want to download the file to the current device
                            docSplitData.splitOffBuffer = buffer;
                            docSplitData.splitOffDocument_Blob = new Blob([buffer], { type: "application/pdf" });

                            //console.log("splitOffDocument_Blob size:", splitOffDocument_Blob.size); // Log the size of the blob


                        });
                    }
                    if (docSplitData.batchInstance) {
                        docSplitData.batchInstance.exportPDFWithOperations([
                            ...operations,
                            { type: "removePages", pageIndexes: selectedPageIndexesForProcessing },
                        ]).then(async (buffer) => {
                            //this is only necessary if you want to download the file to the current device
                            docSplitData.currentDocument_Blob = new Blob([buffer], { type: "application/pdf" });
                            //console.log("currentDocument_Blob size:", currentDocument_Blob.size); // Log the size of the blob

                            const customOptions = { origin: "CaseInformation" };
                            let pageCount = remainingPageIndexes.length;

                            await batchDataService.UpdateBatchDocument(getBatchDocument.BatchDocumentID, pageCount, getBatchDocument.BatchID, customOptions);  // Update Current Document

                            if (buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID) {  // If the split button was pressed, create split document. If type = "Delete" then do nothing.
                                pageCount = selectedPageIndexesForProcessing.length;
                                await batchDataService.InsertBatchDocument(getBatchDocument.BatchDocumentID, pageCount, getBatchDocument.BatchID, customOptions);  // Create the new split off Document in current Batch
                            }
                            docSplitData = batchDataService.getSplitDocumentData();

                            // basePath = \\yt_dev_file.ywcss.local\YWDMS_Dev$\ZZ\
                            // batch Path = 2025\02\22\500920
                            // fileName = 20250222042516.pdf

                            const settingDetailValue = SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey);
                            const siteSettingDetail = JSON.parse(settingDetailValue);
                            docSplitData.basePath = siteSettingDetail.DocumentPath;
                            //docSplitData.basePath = SessionManager.GetValueFromSession(SessionManager.DocumentPathKey);


                            docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.currentDocumentbatchPath + "\\" + docSplitData.currentDocumentFileName;
                            console.log("Update Existing Document Path: " + docSplitData.documentUNCPath);
                            //await ApiManager.DeleteDocumentFromApi(docSplitData.documentUNCPath);
                            await DocumentUtility.SaveFileToPhysicalPath(docSplitData.currentDocument_Blob, docSplitData.documentUNCPath);
                            //saveFile(docSplitData.currentDocument_Blob, docSplitData.currentDocumentFileName, docSplitData.documentUNCPath, docSplitData.buffer);  //Save the modified current document to the server.

                            if (buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID) {  // If the split button was pressed create batch and document. If type = "Delete" then do nothing.
                                docSplitData.splitOffDocumentbatchPath = docSplitData.currentDocumentbatchPath;

                                docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.splitOffDocumentbatchPath + "\\" + docSplitData.splitDocumentFileName;
                                console.log("Insert New Document Path: " + docSplitData.documentUNCPath);
                                await DocumentUtility.SaveFileToPhysicalPath(docSplitData.splitOffDocument_Blob, docSplitData.documentUNCPath);
                                //saveFile(splitOffDocument_Blob, splitDocumentFileName, documentUNCPath, splitOffBuffer);  //Save the split document to the server.
                            }

                            if (pdfViewerRef.current) {
                                await pdfViewerRef.current.handleDocumentExport(buffer, docSplitData.batchInstance);
                            }

                            await handleLoadDocAfterSplit(getBatchDocument.BatchID);

                            await postHardLockAfterSuccessfulEdit(getBatchDocument.BatchID, "performSplitOperation_postHardLock");

                            //await handleDocumentExport(buffer, docSplitData.batchInstance);

                            // if (origin === "CaseInformation" && onLoadDocAfterSplit) {
                            //     await onLoadDocAfterSplit(props.BatchID);
                            // }
                            if (buttonOperationType === EnumUtility.DocumentViewerOperationType.SplitButton.ID) {
                                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentIndexSplitSuccess, true);
                            } else if (buttonOperationType === EnumUtility.DocumentViewerOperationType.DeleteButton.ID) {
                                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentIndexDeleteSuccess, true);
                            }

                        });
                    }
                    return operations;
                });
            } else {
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitNotAvailable); //Prevent split button from being clicked if no pages are selected
            };
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "performSplitOperation", {});
        }
    };

    // Handler for the split all button press
    const handleSplitAllButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
        try {
            const docSplitData = batchDataService.getSplitDocumentData();
            const totalPageCount = docSplitData.batchInstance?.totalPageCount || 0;

            if (totalPageCount <= 1) {
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitAllNotAvailable);
                return;
            }

            const { isLocked } = await checkBatchLockBeforeDocumentAction("handleSplitAllButtonPress");
            if (isLocked) {
                return;
            }

            // Store the arguments for later use
            setSplitArgs({ setOperations, getSelectedPageIndexes });
            // Show the confirmation dialog
            handleConfirmationDialog(EnumUtility.ConfirmDialogType.SplitAllDocument);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSplitAllButtonPress");
        }
    };

    // Handler for confirming the split all
    const handleConfirmSplitAll = async () => {
        try {
            if (splitArgs) {
                const { setOperations } = splitArgs;
                // Perform the split all operation using the stored arguments
                await performSplitAllOperation(setOperations);
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleConfirmSplitAll");
        }
    };

    // Function to perform the split all operation. Every page except the first is split off
    // into its own single-page document, in page order, directly behind the original document.
    const performSplitAllOperation = async (setOperations) => {
        try {
            let docSplitData = batchDataService.getSplitDocumentData();
            const totalPageIndexes = UtilityLibrary.itemsArray(docSplitData.batchInstance?.totalPageCount || 0);
            const pagesToSplitOff = totalPageIndexes.slice(1); // Page 0 remains with the original document

            if (pagesToSplitOff.length === 0) {
                handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentSplitAllNotAvailable);
                return;
            }

            await new Promise((resolve, reject) => {
                setOperations((operations) => {
                    (async () => {
                        try {
                            if (!docSplitData.batchInstance) {
                                resolve();
                                return;
                            }

                            // Export a single-page buffer for every page that will become its own document.
                            const splitOffBuffers = [];
                            for (const pageIndex of pagesToSplitOff) {
                                const pagesToRemove = totalPageIndexes.filter((index) => index !== pageIndex);
                                const pageBuffer = await docSplitData.batchInstance.exportPDFWithOperations([
                                    ...operations,
                                    { type: "removePages", pageIndexes: pagesToRemove },
                                ]);
                                splitOffBuffers.push(pageBuffer);
                            }

                            // Export the buffer for the original document, now containing only its first page.
                            const currentBuffer = await docSplitData.batchInstance.exportPDFWithOperations([
                                ...operations,
                                { type: "removePages", pageIndexes: pagesToSplitOff },
                            ]);
                            docSplitData.currentDocument_Blob = new Blob([currentBuffer], { type: "application/pdf" });

                            const customOptions = { origin: "CaseInformation" };

                            await batchDataService.UpdateBatchDocument(getBatchDocument.BatchDocumentID, 1, getBatchDocument.BatchID, customOptions);  // Update Current Document to a single page

                            docSplitData = batchDataService.getSplitDocumentData();

                            const settingDetailValue = SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey);
                            const siteSettingDetail = JSON.parse(settingDetailValue);
                            docSplitData.basePath = siteSettingDetail.DocumentPath;

                            docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.currentDocumentbatchPath + "\\" + docSplitData.currentDocumentFileName;
                            await DocumentUtility.SaveFileToPhysicalPath(docSplitData.currentDocument_Blob, docSplitData.documentUNCPath);

                            // Create each split off page as its own document, in page order, directly behind the original.
                            for (let index = 0; index < splitOffBuffers.length; index++) {
                                const splitOffBlob = new Blob([splitOffBuffers[index]], { type: "application/pdf" });
                                docSplitData.splitOffDocument_Blob = splitOffBlob;

                                await batchDataService.InsertBatchDocument(
                                    getBatchDocument.BatchDocumentID,
                                    1,
                                    getBatchDocument.BatchID,
                                    { ...customOptions, orderOffset: index + 1, uniqueSuffix: index + 1 }
                                );

                                docSplitData = batchDataService.getSplitDocumentData();
                                docSplitData.basePath = siteSettingDetail.DocumentPath;
                                docSplitData.splitOffDocumentbatchPath = docSplitData.currentDocumentbatchPath;
                                docSplitData.documentUNCPath = docSplitData.basePath + docSplitData.splitOffDocumentbatchPath + "\\" + docSplitData.splitDocumentFileName;
                                await DocumentUtility.SaveFileToPhysicalPath(splitOffBlob, docSplitData.documentUNCPath);
                            }

                            if (pdfViewerRef.current) {
                                await pdfViewerRef.current.handleDocumentExport(currentBuffer, docSplitData.batchInstance);
                            }

                            await handleLoadDocAfterSplit(getBatchDocument.BatchID);

                            await postHardLockAfterSuccessfulEdit(getBatchDocument.BatchID, "performSplitAllOperation_postHardLock");

                            handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentIndexSplitAllSuccess, true);

                            resolve();
                        }
                        catch (innerError) {
                            reject(innerError);
                        }
                    })();

                    return operations;
                });
            });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "performSplitAllOperation");
        }
    };


    //=======================================================================
    // Split Document Process - End
    //=======================================================================


    //=======================================================================
    // ROTATE - Save Document Process - Begin
    //=======================================================================

    // Handler for the save rotate button press
    const handleSaveRotateButtonPress = async (event, { setOperations, getSelectedPageIndexes }) => {
        try {
            const { isLocked } = await checkBatchLockBeforeDocumentAction("handleSaveRotateButtonPress");
            if (isLocked) {
                return;
            }

            // const { documentBuffer, batchInstance } = await BusinessUtility.PerformSaveAfterRotateOperation(getBatchDocument.BatchDocumentID, setOperations, getSelectedPageIndexes);
            const rotateResult = await BusinessUtility.PerformSaveAfterRotateOperation(pdfViewerRef, getBatchDocument.BatchDocumentID, setOperations, getSelectedPageIndexes);
            if (!rotateResult?.hasOperations) {
                return;
            }

            await postHardLockAfterSuccessfulEdit(getBatchDocument.BatchID, "handleSaveRotateButtonPress_postHardLock");
            /*  
             if (pdfViewerRef.current) {
                 await pdfViewerRef.current.handleDocumentExport(documentBuffer, batchInstance);
             } */

            handleNotificationDialog(EnumUtility.BatchDocumentProcess.DocumentRotateSuccess, true);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDialogConfirmAction");
        }
    };

    //=======================================================================
    // ROTATE - Save Document Process - End
    //=======================================================================


    //=======================================================================
    // Save As Process - Begin
    //=======================================================================

    // Handler for the save as button press
    const handleSaveAsButtonPress = async () => {

        const docSplitData = batchDataService.getSplitDocumentData();

        // Export the document as a Blob
        const buffer = await docSplitData.batchInstance.exportPDF();
        const blob = new Blob([buffer], { type: "application/pdf" });

        const paramsBatchDoc = {
            batchDocumentID: getBatchDocument.BatchDocumentID,
        };
        const batchDocApiData = await ApiManager.GetBatchDocumentByIDFromApi(paramsBatchDoc);

        const docLocation = await BusinessUtility.replaceExtensionWithPdf(batchDocApiData.documentLocation);
        if (!docLocation || docLocation.trim().length === 0) {
            docLocation = 'document.pdf' 
        }

        try {
        const handle = await window.showSaveFilePicker({
            suggestedName: docLocation, // Default file name
            types: [
            {
                description: 'PDF Files',
                accept: { 'application/pdf': ['.pdf'] },
            },
            ],
        });

        // Create a writable stream and write the Blob to it
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();

        console.log("Document saved successfully.");
        } catch (error) {
        console.error("Error saving document:", error);
        }
    };

    //=======================================================================
    // Save As Process - End
    //=======================================================================

    const handleCopyPathButtonPress = async () => {
        try {
        //getBatchDocument.DocumentUNCPath
      const loginUserInfo = sessionService.getUser();
      const { stateID, siteID, legacyUserID: userID } = loginUserInfo || {};
      // Get temp file set det
      const setDetailIDs = [ClientType.SettingsDetail.DMS_Scanning__Copy_Link_Temp_Path,
      ClientType.SettingsDetail.UI_Miscellaneous__Success_Notification_TIMER]
      const params = {
        settingsDetailIDList: setDetailIDs.join(","),
        yTracSiteID: stateID
      }
      const settingDetails = await ApiManager.GetSettingsDetailValuesFromApi(params); 
      const messageContentData = await SharedService.getMessageContent(ClientType.MessageContent.N_UI7057_Document_Path_Copied);
      const timerValue = (settingDetails?.settingDetailsApiData.find(
        value => parseInt(value.settingsDetailID) === ClientType.SettingsDetail.UI_Miscellaneous__Success_Notification_TIMER)?.settingsDetailValue || 3) * 1000;
      await SharedService.handleCopyPathButtonPress(getBatchDocument, uncBatchDocumentUrl, settingDetails, { stateID, siteID, userID }, masterServerDBSchema);
       // Display notification dialog
      handleNotificationDialog({ NotificationType: "success", Message: messageContentData?.messageText}, true,
        timerValue, "top-right"
      )
    }
    catch (err) {
      handleNotificationDialog({ NotificationType: "error", Message: 'Error occured while coping the file path' }, true,
        3000, "top-right"
      );
    }   
  } 


    const handlePDFViewerError = async(errorMessage) => {
        const loginUserInfo = sessionService.getUser();
        const { stateName, firstName, lastName} = loginUserInfo
        const { BatchDocumentID, BatchID } = getBatchDocument
        const currentDate = UtilityLibrary.formatDate(new Date(), customDateFormat);
        
        const dialogMessage = `Document Preview Failed. Please contact Helpdesk.
        Exception = ${errorMessage}
        Date/Time of Error = ${currentDate}
        State = ${stateName}
        User = ${firstName} ${lastName}
        Region =  ${configLibrary.hostedEnvironment}            
        Batch ID = ${BatchID}
        Document ID = ${BatchDocumentID}`;
        
        handleNotificationDialog({ NotificationType: "error", Message: dialogMessage })
  }

//=======================================================================
//  - Begin
//=======================================================================


//=======================================================================
//  - End
//=======================================================================


//=======================================================================
// Tabs Feature - Begin
//=======================================================================


//=======================================================================
// Tabs Feature - End
//=======================================================================





    const mainContent = (
        <div className="content-main-container">
            <div className="pane-wrap-container">
                <div className="pane-main-container">
                    <div className="form-section docViewerForm" style={{ height: '100%', overflow: 'hidden' }}>
                        <Box sx={{ height: '100%' }}>
                            {/* Content Section */}
                            <Box
                                hidden={!caseInfoFormVisibility}
                                sx={{ height: '100%' }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                {/* Sticky Case Information Section */}
                                <div 
                                    style={{ 
                                        flexShrink: 0,
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        backgroundColor: 'white',
                                        padding: '16px', 
                                        width: '100%' 
                                    }}
                                >
                                    {/* Top Section (Yellow) */}
                                    <div className="form-caseInfo-container">
                                        {!(formFieldAccess.caseNumberLbl?.hide ?? false) && (
                                            <div className="form-caseInfo-field">
                                                <label className="text-wrapper-subtitle caseInfo-Title">Case ID:</label>
                                                <label id="caseNumberLbl" name="caseNumberLbl" className="text-wrapper-subtitle caseInfo-Content">{currentBatchFormData.caseNumber || ''}</label>
                                            </div>
                                        )}
                                        {!(formFieldAccess.cpNameLbl?.hide ?? false) && (
                                            <div className="form-caseInfo-field">
                                                <label className="text-wrapper-subtitle caseInfo-Title">CP:</label>
                                                <label id="cpNameLbl" name="cpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{(currentBatchFormData.cpFirstName || ' ') + ' ' + (currentBatchFormData.cpLastName || ' ')}</label>
                                            </div>
                                        )}
                                        {!(formFieldAccess.cpSSNLbl?.hide ?? false) && (
                                            <div className="form-caseInfo-field">
                                                <label className="text-wrapper-subtitle caseInfo-Title">CP SSN:</label>
                                                <label id="cpSSNLbl" name="cpSSNLbl" className="text-wrapper-subtitle caseInfo-Content">{currentBatchFormData.cpssn || ''}</label>
                                            </div>
                                        )}
                                    </div>
                                    <div className="form-caseInfo-container">
                                        {!(formFieldAccess.caseWorkerLbl?.hide ?? false) && (
                                            <div className="form-caseInfo-field">
                                                <label className="text-wrapper-subtitle caseInfo-Title">Case Worker:</label>
                                                <label id="caseWorkerLbl" name="caseWorkerLbl" className="text-wrapper-subtitle caseInfo-Content">{currentBatchFormData.caseWorker || ''}</label>
                                            </div>
                                        )}
                                        {!(formFieldAccess.ncpNameLbl?.hide ?? false) && (
                                            <div className="form-caseInfo-field">
                                                <label className="text-wrapper-subtitle caseInfo-Title">NCP:</label>
                                                <label id="ncpNameLbl" name="ncpNameLbl" className="text-wrapper-subtitle caseInfo-Content">{(currentBatchFormData.ncpFirstName || '') + ' ' + (currentBatchFormData.ncpLastName || '')}</label>
                                            </div>
                                        )}
                                        {!(formFieldAccess.ncpSSNLbl?.hide ?? false) && (
                                            <div className="form-caseInfo-field">
                                                <label className="text-wrapper-subtitle caseInfo-Title">NCP SSN:</label>
                                                <label id="ncpSSNLbl" name="ncpSSNLbl" className="text-wrapper-subtitle caseInfo-Content">{currentBatchFormData.ncpssn || ''}</label>
                                            </div>
                                        )}
                                    </div>
                                    <div className='d-flex'>
                                        <div className='indicatorDiv'>
                                             {!(formFieldAccess.confidentialCaseLbl?.hide ?? false) && (
                                                <label id="confidentialCaseLbl" name="confidentialCaseLbl" className='indicatorLabel'>Confidential</label>
                                            )}
                                            {!(formFieldAccess.familyViolenceLbl?.hide ?? false) && (
                                                <label id="familyViolenceLbl" name="familyViolenceLbl" className='indicatorLabel'>{currentBatchFormData.fviChipDisplay}</label>
                                                )}
                                            {!(formFieldAccess.ndiLbl?.hide ?? false) && (
                                                <label id="ndiLbl" name="ndiLbl" className='indicatorLabel'>{currentBatchFormData.ndiChipDisplay}</label>
                                            )}
                                            {!(formFieldAccess.goodCauseLbl?.hide ?? false) && (
                                                <label id="goodCauseLbl" name="goodCauseLbl" className="indicatorLabel indicatorLabelDisabled">Good Cause</label>
                                            )}
                                            {!(formFieldAccess.nonCoopLbl?.hide ?? false) && (
                                                <label id="nonCoopLbl" name="nonCoopLbl" className="indicatorLabel indicatorLabelDisabled">Non Coop</label>
                                            )}
                                            {!(formFieldAccess.conflictCaseLbl?.hide ?? false) && (
                                                <label id="conflictCaseLbl" name="conflictCaseLbl" className="indicatorLabel">Conflict case</label>
                                            )}
                                            {!(formFieldAccess.caseClosedLbl?.hide ?? false) && (
                                                <label id="caseClosedLbl" name="caseClosedLbl" className="indicatorLabel">Closed Case</label>
                                            )}
                                        </div>
                                    </div>
                                    <div className='row' style={{ padding: "4px 25px" }}>
                                        <div className='col-12' style={{ padding: "2px", borderBottom: '2px solid grey' }}>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ padding: "5px 25px" }}>
                                            <label
                                                id="documentNameLbl"
                                                name="documentNameLbl"
                                                className="text-wrapper-subtitle caseInfo-Title"
                                                style={{ userSelect: 'text', cursor: 'text' }}
                                            >
                                            {getBatchDocument.DocumentName_Displayed}
                                            </label>
                                </div>
                                {/* Scrollable Content Area */}
                                <div style={{ flex: 1, minHeight: 0 }}>
                                    {/* Bottom Section - Document Viewer*/}
                                    {(enableShowBatchDocument) && (
                                        (uncBatchDocumentUrl) &&
                                        <Paper elevation={2} className="document-viewer" sx={{ boxShadow: "none", height: '100%' }}>
                                            {!(formFieldAccess.documentViewerVwr?.hide ?? false) && (
                                                <div style={{ width: '100%', height: '100%' }}>
                                                    <PdfViewerComponent
                                                        ref={pdfViewerRef}
                                                        BatchID={getBatchDocument.BatchID}
                                                        BatchDocumentID={getBatchDocument.BatchDocumentID}
                                                        origin="CaseInformation"
                                                        id="documentViewerBatchVwr"
                                                        name="documentViewerBatchVwr"
                                                        key={uncBatchDocumentUrl}
                                                        document={uncBatchDocumentUrl}
                                                        onSplitButtonPress={handleSplitButtonPress}
                                                        onSplitAllButtonPress={handleSplitAllButtonPress}
                                                        onSaveRotateButtonPress={handleSaveRotateButtonPress}
                                                        onSaveAsButtonPress={handleSaveAsButtonPress}
                                                        onDeleteButtonPress={handleDeleteButtonPress}
                                                        viewerAccessPermissions={documentViewerAccessPermissions}
                                                        onCopyPathButtonPress={handleCopyPathButtonPress}
                                                        persistViewerPreferences={true}
                                                        viewerPreferencesSessionKey="LegacyIndexViewerPreferences"
                                                        style={{ width: '100%' }}
                                                        onPDFReadError={handlePDFViewerError}
                                                        onEditorCloseRequest={handleDocumentEditorCloseRequest}
                                                    />
                                                </div>
                                            )}
                                        </Paper>
                                    )}
                                </div>
                                </div>
                            </Box>
                        </Box>
                    </div>
                </div>
            </div >
        </div >
    );

    return (
        <div style={{ height: '100%' }}>
            {mainContent}

            <AlertNotification
                alertType={alertProps.type}
                message={alertProps.message}
                open={alertProps.open}
                onClose={handleAlertClose}
            />

            {/* Include the Confirmation Dialog component */}
            <ConfirmationDialog
                openConfirmation={confirmDialogOpen}
                dialogContent={confirmationDialogContent}
                onCloseConfirmation={handleCloseConfirmDialog}
                onConfirmDialog={(param) => handleDialogConfirmAction(param)}
            />

            {/* Include the Notification Dialog component */}
            <NotificationDialog
                openNotification={notificationDialogOpen}
                dialogContent={notificationDialogContent}
                onCloseNotification={handleCloseNotificationDialog}
                isAutoClose={timerAutoCloseNotificationDialog}
                timerDuration={timerNotificationDialogClose}
                position={notificationDialogPosition || "center"}
            />

            {/* Include the loader component */}
            <PageLoader isPageLoading={isPageLoading} />
        </div>
    );
}));

export default CaseInformation;






    //=======================================================================
    //  - Begin
    //=======================================================================

    //=======================================================================
    //  - End
    //=======================================================================


    


    //=======================================================================
    //  - Begin
    //=======================================================================

    //=======================================================================
    //  - End
    //=======================================================================


